import React, { Component } from "react";
import { connect } from "react-redux";
import isSandboxModeHOC from "HOC/isSandboxModeHOC";
import { compose } from "redux";
import {
  getAuthenticatedState,
  getLoggingState,
  getOrganizationOnboardStatus,
  getOrganizationsLength,
  getUserOrganizationState,
  getVerifyingTokenState,
} from "../../AppSelectors";
import BasicLoader from "../../../../components/Loaders/BasicLoader";
import { getUrlParams } from "util/utility";
import showOnboardingFeatureHOC from "HOC/showOnboardingFeatureHOC";

// TODO: change this to FC
class RedirectPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        username: "",
        password: "",
      },
    };
  }

  componentDidMount() {
    const botParam = getUrlParams("konvo");
    if (!this.props.isAuthenticated) {
      if (botParam) {
        this.props.history.push("/login?konvo=true");
      } else {
        this.props.history.push("/login");
      }
    } else if (this.props.organizationLength > 0) {
      if (this.props.isOrganizationOnboarded) {
        if (this.props.showOnboardingFeature) {
          this.props.history.push("/onboarding");
        } else if (botParam) {
          this.props.history.push("/inbox?konvo=true");
        } else {
          this.props.history.push("/inbox");
        }
      } else {
        this.props.history.push("/signup/whatsapp");
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const botParam = getUrlParams("konvo");

    if (
      this.props.isAuthenticated &&
      prevProps.isFetchingOrganizationDetails &&
      !this.props.isFetchingOrganizationDetails
    ) {
      if (this.props.organizationLength > 0) {
        if (this.props.isOrganizationOnboarded) {
          if (this.props.showOnboardingFeature) {
            this.props.history.push("/onboarding");
          } else if (botParam) {
            this.props.history.push("/inbox?konvo=true");
          } else {
            this.props.history.push("/inbox");
          }
        } else {
          this.props.history.push("/signup/whatsapp");
        }
      }
    }
  }

  render() {
    return <BasicLoader />;
  }
}

function mapStateToProps(state, props) {
  return {
    isAuthenticated: getAuthenticatedState(state),
    isLoggingIn: getLoggingState(state),
    isVerifyingToken: getVerifyingTokenState(state),
    isFetchingOrganizationDetails: getUserOrganizationState(state),
    organizationLength: getOrganizationsLength(state),
    isOrganizationOnboarded: getOrganizationOnboardStatus(state),
  };
}

export default compose(
  isSandboxModeHOC,
  showOnboardingFeatureHOC,
  connect(mapStateToProps),
)(RedirectPage);
